import React, { useEffect, useState } from 'react';
import '../styles/DataModeButtons.css'
import { data } from './Board.js';
import ReactGA from 'react-ga4';

ReactGA.initialize('G-7HQ6K7SGK5'); //primal nus latest -GA
function DataModeButtons() {

    const [dataMode, setdataMode] = useState(data.mode);
    
    const changeDataMode =(mode) => {
        data.mode = mode;
        setdataMode(mode);
        console.log(`data mode : ${mode}`);
        ReactGA.event({
            category: 'Button',
            action: 'Click',
            label: `${mode} data mode Button is clicked`
          });
    }

    document.addEventListener('keydown', (event) => {
        var name = event.key;
        if (name === 'o') {
            setdataMode("obstacle");
        }
        if (name === 'g') {
            setdataMode("goal");
        }
        if (name === 'a') {
            setdataMode("agent");
        }
        // console.log(`data mode : ${dataMode}`);
    }, false);

    return (
            <div className="
            datamode-btn-group">
                <button className={dataMode === 'obstacle' ? 'btn-primary dataMode-btn active' : 'btn-primary dataMode-btn'} onClick={() => changeDataMode('obstacle')}>Obstacle</button>
                <button className={dataMode === 'agent' ? 'btn-primary dataMode-btn active' : 'btn-primary dataMode-btn'} onClick={() => changeDataMode('agent')}>Agent</button>
                <button className={dataMode === 'goal' ? 'btn-primary active dataMode-btn' : 'btn-primary dataMode-btn'} onClick={() => changeDataMode('goal')}>Goal</button>
            </div>
    );
}

export default DataModeButtons;